// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ViewRef } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
// Store
import { Store } from '@ngrx/store'
// Translate
import { TranslateService } from '@ngx-translate/core'
// RxJS
import { Observable, Subject } from 'rxjs'
import { finalize, takeUntil, tap } from 'rxjs/operators'
import { environment } from '../../../../../environments/environment'
// Auth
import { AuthNoticeService, AuthService, Login,User } from '../../../../core/auth'
import { AppState } from '../../../../core/reducers'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { AppService, ConnectionService,ParameterService,StateService } from '../../../../services'
import { Meta,BrowserModule  } from '@angular/platform-browser/';

import { MenuConfig } from '../../../../core/_config/menu.config'
import {  PageService } from '../../../../services'

import { MatSnackBar } from '@angular/material';

/**
 * ! Just example => Should be removed in development
 */
const DEMO_PARAMS = {
	EMAIL: 'utilisateur@exemple.com',
	PASSWORD: ''
}

@Component({
	selector: 'atyl-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup
	loading = false;
	isLoggedIn$: Observable<boolean>
	errors: any = [];
	hidePassword: boolean = true;

	private unsubscribe: Subject<any>

	private returnUrl: any
	
	private openid:boolean=false;
	
    private isNomade:string='false';

	metaEl: HTMLMetaElement;
	cacheClientVersion:string="";
	redirectionUrl = "";
	isCropped = false;

	// Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private router: Router,
		private auth: AuthService,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private appService: AppService,
		private paramService: ParameterService,
		private stateService: StateService,
		private connectionService: ConnectionService,
		private meta: Meta,
		private pageService:PageService,
		private snackBar: MatSnackBar
	) {
		this.unsubscribe = new Subject()
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.isNomade = localStorage.getItem('ATYL_MODE_NOMADE')
		if (this.isNomade != 'true') {
						
						
				this.initLoginForm()
		}
		// redirect back to the returnUrl before login
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params['returnUrl'] || '/'
		})
	}
	ngAfterViewInit(): void {
			this.metaEl=this.meta.getTag('name = "version"')
			this.cacheClientVersion=this.metaEl.content;
			  
	}
		
	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null)
		this.unsubscribe.next()
		this.unsubscribe.complete()
		this.loading = false
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		// demo message to show
		if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			// const initialNotice = `Saisissez votre email
			// <strong>${DEMO_PARAMS.EMAIL}</strong> et votre mot de passe
			// <strong>${DEMO_PARAMS.PASSWORD}</strong> pour continuer.`

			const initialNotice = 
				"Saisissez votre nom d'utilisateur ou votre adresse de messagerie" 
				+ " et votre mot de passe pour vous connecter."
			this.authNoticeService.setNotice(initialNotice, 'info')
		}

		this.loginForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			password: [DEMO_PARAMS.PASSWORD, Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			]
		})

		this.route.queryParams.subscribe(params => {
			if (params["token"]) {
				environment.tokenAtyl = params["token"];
			}
			if (params["url"]) {
				this.redirectionUrl = params["url"];
			}
			if (params["isCropped"]) {
				this.isCropped = params["isCropped"];
				
				this.stateService.cropped(this.isCropped);
			}
		})

		this.loading = true
		this.connectionService.getToken()
		    .subscribe(
			(token: JSONRpcResponse) => {
			
			console.log("LoginComponent getToken ",token.result);
			
			environment.tokencsrf = token.result.token
			this.openid=false;
			this.loading = false
			setTimeout(() => {
				if (this.cdr && !(this.cdr as ViewRef).destroyed) {
					this.cdr.detectChanges()
				}
			})
			this.auth
			.kindOpenId()
			.pipe(
				tap(connect => {
					if (connect=="login")
					   this.openid=true;
				}),
				takeUntil(this.unsubscribe),
				finalize(() => {
					
					this.cdr.detectChanges();
				})
			).subscribe(() => {
			});
			
			if (environment.tokenAtyl) {
				this.loading = true;
				this.auth.loginByToken()
					.pipe(
						tap(user => {
							if (user) {
								this.afterLoginSuccess(user);
							}
						})
					).subscribe(() => {
					})
			}
			
			/*this.connectionService.send401().subscribe(
				(res401: any) => {
					console.log(res401)
				},
				error => {
					if (error.status === 401) {
                        */
						this.auth
							.loginLDAP()
							.pipe(
								tap(user => {
								
								/*
						OPEN ID AUTOCONNECT
						*/
						console.log("LoginComponent loginLDAP ",user);
						if (user.openID 
						&& user.openID.user!=undefined
						&& user.openID.token!=undefined
						&& user.openID.connect!=undefined
						&& user.openID.connect=="OK"
						 ) {
									
							this.stateService.justConnectedUpdate(true);
							this.store.dispatch(new Login({ authToken: user.openID.token }))
							
							this.connectionService.versions().subscribe((vs:JSONRpcResponse) => {
										if (vs.result)  {
											 let versions:any=vs.result;
											 
											 versions.version_meta=this.cacheClientVersion;
											 //this.viewVersion=true;
											 versions.good_client=( versions.version_meta==versions.client);
											 													
											this.stateService.updateVersions( versions);
											 console.log("versions",versions);
										}
							})
							
							this.redirectTo();
						}
								
									if (user) {
										
										this.connectionService.versions().subscribe((vs:JSONRpcResponse) => {
													if (vs.result)  {
														 let versions:any=vs.result;
														 
														 versions.version_meta=this.cacheClientVersion;
														 //this.viewVersion=true;
														 versions.good_client=( versions.version_meta==versions.client);
														 
														this.stateService.updateVersions(versions);
														 console.log("versions",versions);
													}
										})
										
										this.paramService.getTiersTypeList().subscribe(res => {
																	       if (res.result!=undefined)
																	             this.stateService.updateTypeTiers(res.result);
																	});
										
										
										this.paramService.application().subscribe( (res:JSONRpcResponse) => {
										                                if (res.result!=undefined)
										                                    this.stateService.updateApplication(res.result);
										  });
										
										  this.pageService.getMenuList().subscribe((res:JSONRpcResponse) => {
				  	                              if (res.result!=undefined) {
				  										const mn = new MenuConfig(this.pageService);
				  										
				  										mn.setItems(res.result);
				  										this.stateService.updateMenu(mn.configs);
				  	                                    console.log("menu",mn.configs);
				  									  
				  									}  
										  });
										  
										this.stateService.justConnectedUpdate(true);
										this.store.dispatch(new Login({ authToken: user.accessToken }))

										this.redirectTo();
									} else {

									}
								}),
								takeUntil(this.unsubscribe),
								finalize(() => {
									this.loading = false
									this.detectChanges()
								})
							).subscribe(() => {

							})
				/*	}
				}
			)*/
		})

	}

	/**
	 * Form Submit
	 */
	submit() {

		const controls = this.loginForm.controls
		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			)
			return
		}

		this.loading = true

		const authData = {
			email: controls['email'].value,
			password: controls['password'].value
		}


		this.connectionService.getToken().subscribe((token: JSONRpcResponse) => {
			environment.tokencsrf = token.result.token
			this.loading = false
			this.detectChanges()
			this.auth
				.login(authData.email, authData.password)
				.pipe(
					tap(user => {
						if (user) {
							this.afterLoginSuccess(user);
						} else {
							this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger')

							Object.keys(controls).forEach(controlName =>
								controls[controlName].setValue('')
							)
						}
					}),
					takeUntil(this.unsubscribe),
					finalize(() => {
						this.loading = false
						this.detectChanges()
					})
				).subscribe(() => {
				})
		})
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		if (this.loginForm!=undefined) {
			const control = this.loginForm.controls[controlName]
			if (!control) {
				return false
			}
	
			const result = control.hasError(validationType) && (control.dirty || control.touched)
			return result
		}
	}

	private detectChanges()
	{
		if (!this.cdr['destroyed']) {
			this.cdr.detectChanges();
		}
	}

	private afterLoginSuccess(user)
	{
		this.connectionService.versions().subscribe((vs:JSONRpcResponse) => {
			if (vs.result)  {
				let versions:any=vs.result;
				
				versions.version_meta=this.cacheClientVersion;
				//this.viewVersion=true;
				versions.good_client=( versions.version_meta==versions.client);
																	
				this.stateService.updateVersions(versions);
					console.log("versions",versions);
			}
		})
		this.paramService.getTiersTypeList().subscribe((res:JSONRpcResponse) => {
			       if (res.result!=undefined)
			             this.stateService.updateTypeTiers(res.result);
			});
		this.paramService.application().subscribe( (res:JSONRpcResponse) => {
			if (res.result!=undefined)
				this.stateService.updateApplication(res.result);
		});
		
		this.pageService.getMenuList().subscribe((res:JSONRpcResponse) => {
          if (res.result!=undefined) {
				const mn = new MenuConfig(this.pageService);
				
				mn.setItems(res.result);
				this.stateService.updateMenu(mn.configs);
				console.log("menu2",mn.configs);
			  
			}  
		});
		
		this.stateService.justConnectedUpdate(true);
		this.store.dispatch(new Login({ authToken: user.accessToken }))
		
		this.redirectTo();
	}

	private redirectTo(url = null)
	{
		let redirection = url;
		if (!redirection && this.redirectionUrl) {
			redirection = this.redirectionUrl;
		}
		this.router.navigate(["/home"],{queryParams: {redirect: redirection, isCropped: this.isCropped}});
	}
	
	connectOpenId() {
			this.auth
				.loginOpenId()
				.pipe(
					tap(user => {
						if(user instanceof User)
						{
							this.store.dispatch(new Login({authToken: user.accessToken}));
	                        
							this.paramService.getTiersTypeList().subscribe(res => {
							       if (res.result!=undefined)
							             this.stateService.updateTypeTiers(res.result);
							});
							
							
							this.paramService.application().subscribe( (res:JSONRpcResponse) => {
							                                if (res.result!=undefined)
							                                    this.stateService.updateApplication(res.result);
							  });

							
							  this.pageService.getMenuList().subscribe((res:JSONRpcResponse) => {
							            if (res.result!=undefined) {
							  				const mn = new MenuConfig(this.pageService);
							  				
							  				mn.setItems(res.result);
							  				this.stateService.updateMenu(mn.configs);
							                  console.log("menu",mn.configs);
							  			  
							  			}  
							  });
							
							
							
							this.connectionService.versions().subscribe((vs:JSONRpcResponse) => {
										if (vs.result)  {
											 let versions:any=vs.result;
											 
											 versions.version_meta=this.cacheClientVersion;
											 //this.viewVersion=true;
											 versions.good_client=( versions.version_meta==versions.client);
											 
											this.stateService.updateVersions(versions);
											 console.log("versions",versions);
										}
							})

							


							  
							
	                           const r:any=localStorage.getItem('AtylreturnUrl');
							   localStorage.removeItem('ConnectOpenID');
							/*if(this.returnUrl != "/")
								this.router.navigateByUrl(this.returnUrl); // Main page
							else*/
							//	this.router.navigateByUrl("/home"); // Main page
								this.router.navigate(["/home"],{queryParams: {redirect: r}}); 
						}else {
							//this.openid=false;
							console.log("loginOpenId",user);
							let item:any =localStorage.getItem("ConnectOpenID");
							
							if(item && user.userFound!=undefined && ! user.userFound){
									let messageCnx:string='Connexion fonctionnelle impossible:';
									messageCnx+='\nVotre utlisateur est inconnu d\'Atyl';
									messageCnx+='\nVeuillez contacter votre administrateur';
										this.snackBar.open(messageCnx,'', {
									           duration: 3000,
											   panelClass: ['success-snackbar']
									 });		
							} 
							
								localStorage.removeItem ('ConnectOpenID');
							
							 if (user!=undefined && user.auth_point!=undefined && user.auth_point ) {
								localStorage.setItem('ConnectOpenID', "TRUE");
								window.location.href=user.auth_point;
							}
							
						}
					}),
					takeUntil(this.unsubscribe),
					finalize(() => {
						this.loading = false;
						this.cdr.detectChanges();
					})
				).subscribe(() => {
				});
	}
}
